import React from 'react';
import { Button } from 'react-bootstrap';
import ReactSelectize from 'react-selectize';
import { pathOr } from 'ramda';

class ComponentSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isSelecting: false };

        this.pageId = null;

        this.onChange = this.onChange.bind(this);
        this.selectComponent = this.selectComponent.bind(this);
        this.fetchComponent = this.fetchComponent.bind(this);
    }

    onChange(option) {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        const selectedObjectData = model.objectData.filter(item => manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue === pathOr(null, ['value'], option))
            .map((item) => {
                const clone = JSON.parse(JSON.stringify(item));
                clone.isSelected = true;
                return clone;
            });

        manywho.state.setComponent(this.props.id, { objectData: selectedObjectData }, this.props.flowKey, true);
        manywho.component.handleEvent(this, model, this.props.flowKey);
    }

    fetchComponent(event) {
        event.preventDefault();
        event.stopPropagation();
        let element = event.target;
        while(element.id.indexOf('element-') === -1) {
            element = element.parentNode;
        }

        if (element.classList.contains('container-wrapper'))
            return;

        const componentId = element.id.split('element-')[1];

        this.onChange({ value: componentId });

        document.getElementById(this.pageId).removeEventListener('click', this.fetchComponent);

        this.setState({ isSelecting: false });
    }

    selectComponent(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.state.isSelecting)
            document.getElementById(this.pageId).addEventListener('click', this.fetchComponent);
        else
            document.getElementById(this.pageId).removeEventListener('click', this.fetchComponent);

        this.setState({ isSelecting: !this.state.isSelecting });
    }

    componentWillMount() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        this.pageId = manywho.utils.getObjectDataProperty(model.tags, 'PageId').contentValue;
    }

    componentWillUnmount() {
        document.getElementById(this.pageId).removeEventListener('click', this.fetchComponent);
    }

    render() {
        manywho.log.info('Rendering Component Selector: ' + this.props.id);

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const state = this.props.isDesignTime ? 
            { error: null, loading: false} : 
            manywho.state.getComponent(this.props.id, this.props.flowKey);

        const outcomes = manywho.model.getOutcomes(this.props.id, this.props.flowKey);

        let options = null;
        let value = null;

        let props = {
            disabled: !model.isEnabled || !model.isEditable || this.state.isSelecting || (state && state.loading) || this.props.isDesignTime,
            placeholder: model.hintValue || 'Select a Component'
        };

        const wrapperClasses = ['select-wrapper', 'input-group'];

        if (!manywho.utils.isEmptyObjectData(model) && !this.props.isDesignTime) {
            const columnTypeElementPropertyId = manywho.component.getDisplayColumns(model.columns)[0].typeElementPropertyId;

            props.onValueChange = this.onChange;

            if (state && state.objectData)
                value = state.objectData.map((item) => manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue)[0];
            else
                value = model.objectData.filter((item) => item.isSelected)
                    .map((item) => manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue)[0];

            options = model.objectData.map((item) => {
                const label = item.properties.filter((value) => manywho.utils.isEqual(value.typeElementPropertyId, columnTypeElementPropertyId, true))[0];
                const id = manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue;
                return {value: id, label: label.contentValue};
            });

            if (value && options)
                value = options.find(option => option.value == value);

            props.options = options;
            props.value = value;
        }

        const selectButton = !this.state.isSelecting ? <Button bsStyle="primary" onClick={this.selectComponent} disabled={state.loading}>Select</Button>
            : <Button bsStyle="default" onClick={this.selectComponent} disabled={state.loading}>Stop</Button>;

        let containerClassNames = ['form-group'];

        if ((typeof model.isValid !== 'undefined' && model.isValid == false) || (state.error))
            containerClassNames.push('has-error');

        if (model.isVisible == false)
            containerClassNames.push('hidden');

        containerClassNames = containerClassNames.concat(manywho.styling.getClasses(this.props.parentId, this.props.id, 'select', this.props.flowKey));

        const outcomeButtons = outcomes && outcomes.map((outcome) => {
                return React.createElement(manywho.component.getByName('outcome'), {
                    id: outcome.id,
                    flowKey: this.props.flowKey
                });
            });

        const required = (model.isRequired) ? React.DOM.span({className: 'input-required'}, ' *') : null;

        return <div className={containerClassNames.join(' ')}>
            <label for={this.props.id}>
                {model.label}
                {required}
            </label>
            <div className={wrapperClasses.join(' ')}>
                <ReactSelectize.SimpleSelect {...props} /> 
                {selectButton}
            </div>
            <span className="help-block">{state.error && state.error.message}</span>
            <span className="help-block">{model.helpInfo}</span>
            {outcomeButtons}
        </div>;
    }
}

export default ComponentSelector;